import React from "react"

import Link from "~components/Link"
import HoverMenu from "~components/HoverMenu"
import * as style from "./Menu.module.scss"

import sampleCodeCatalog from './sampleCodeCatalog.png'
import aiDevZoneImage from './aiDevZone.png'
import connectFeatured from './connectFeaturedImage.png'

const Menu = ({ microcopy }) => (
  <nav role="navigation" className={style.menu}>
    <ul>
      {process.env.GATSBY_FEATURE_PRODUCT_DROPDOWN === "true" && (
        <li className={style.dropdownParent} microcopy={microcopy}>
          <span className={style.link}>{microcopy.text("headers.primary.links.explore.text")}</span>
          <HoverMenu center noPadding>
            <div className={style.menuDropdown}>
              <div className={style.linkSection}>
                <div>
                  <div className={style.submenu}>
                    <span className={style.linkSectionTitle}>
                      {microcopy.text("headers.primary.links.overview.text")}
                    </span>
                    <Link
                      to="/platform/"
                      microcopy={microcopy}
                      className={style.dropdownLink}
                    >
                      {microcopy.text("headers.primary.links.learn.text")}
                    </Link>
                    <Link
                      to="/sign/"
                      microcopy={microcopy}
                      className={style.dropdownLink}
                    >
                      {microcopy.text("headers.primary.links.learn-sign.text")}
                    </Link>
                    <Link
                      to="/box-ui-elements/"
                      microcopy={microcopy}
                      className={style.dropdownLink}
                    >
                      {microcopy.text("headers.primary.links.buie.text")}
                    </Link>
                    <Link
                      to="/ai-dev-zone/"
                      microcopy={microcopy}
                      className={style.dropdownLink}
                    >
                      {microcopy.text("headers.primary.links.ai_dev_zone.text")}
                    </Link>
                  </div>
                </div>
              </div>
              <div className={style.featuredSection}>
                <img alt="" src={aiDevZoneImage} />
                <figcaption>
                  <span className={style.tagFeatured}>
                    {microcopy.text("headers.primary.featured.tag.text")}
                  </span>
                  <span
                    microcopy={microcopy}
                    className={style.featuredTitle}
                  >
                    {microcopy.text("headers.primary.featured.title.text")}
                  </span>
                  {microcopy.text("headers.primary.featured.details.text")}
                </figcaption>
                <Link
                  to="/ai-dev-zone/"
                  microcopy={microcopy}
                  className={style.featuredLink}
                >
                  {microcopy.text("headers.primary.featured.cta.text")}
                </Link>
              </div>
            </div>
          </HoverMenu>
        </li>
      )}
      {process.env.GATSBY_FEATURE_DOCUMENTATION_DROPDOWN === "true" && (
        <li className={style.dropdownParent} microcopy={microcopy}>
          <span className={style.link}>{microcopy.text("headers.primary.links.develop.text")}</span>
          <HoverMenu center noPadding>
            <div className={style.menuDropdown}>
              <div className={style.linkSection}>
                <div>
                  <div className={style.submenu}>
                    <span className={style.linkSectionTitle}>
                      {microcopy.text("headers.primary.links.documentation.text")}
                    </span>
                    <Link
                      to="/reference/"
                      microcopy={microcopy}
                      className={style.dropdownLink}
                    >
                      {microcopy.text("headers.primary.links.api_reference.text")}
                    </Link>
                    <Link
                      to="/guides/"
                      microcopy={microcopy}
                      className={style.dropdownLink}
                    >
                      {microcopy.text("headers.primary.links.guides.text")}
                    </Link>
                    <span className={style.linkSectionTitle}>
                      {microcopy.text("headers.primary.links.additional_resouces.text")}
                    </span>
                    <Link
                      to="/sdks-and-tools/"
                      microcopy={microcopy}
                      className={style.dropdownLink}
                    >
                      {microcopy.text("headers.primary.links.sdks_and_tools.text")}
                    </Link>
                    <Link
                      to={microcopy.text("headers.primary.links.blog.url")}
                      microcopy={microcopy}
                      className={style.dropdownLink}
                    >
                      {microcopy.text("headers.primary.links.blog.text")}
                    </Link>
                    <Link
                      to="/sample-code/"
                      microcopy={microcopy}
                      className={style.dropdownLink}
                    >
                      {microcopy.text("headers.primary.links.sample_code.text")}
                    </Link>
                  </div>
                </div>
              </div>
              <div className={style.featuredSection}>
                <img alt="" src={sampleCodeCatalog} />
                <figcaption>
                  <span className={style.tagFeatured}>
                    {microcopy.text("headers.primary.develop_featured.tag.text")}
                  </span>
                  <span
                    microcopy={microcopy}
                    className={style.featuredTitle}
                  >
                    {microcopy.text("headers.primary.develop_featured.title.text")}
                  </span>
                  {microcopy.text("headers.primary.develop_featured.details.text")}
                </figcaption>
                <Link
                  to="/sample-code/"
                  microcopy={microcopy}
                  className={style.featuredLink}
                >
                  {microcopy.text("headers.primary.develop_featured.cta.text")}
                </Link>
              </div>
            </div>
          </HoverMenu>
        </li>
      )}
      {process.env.GATSBY_FEATURE_COMMUNITY === "true" && (
        <li className={style.dropdownParent} microcopy={microcopy}>
        <span className={style.link}>{microcopy.text("headers.primary.links.connect.text")}</span>
        <HoverMenu center noPadding>
          <div className={style.menuDropdown}>
            <div className={style.linkSection}>
              <div>
                <div className={style.submenu}>
                  <span className={style.linkSectionTitle}>
                    {microcopy.text("headers.primary.links.community.text")}
                  </span>
                  <Link
                    to="https://community.box.com/"
                    microcopy={microcopy}
                    className={style.dropdownLink}
                  >
                    {microcopy.text("headers.primary.links.community_forum.text")}
                  </Link>
                  <Link
                    to="/support/"
                    microcopy={microcopy}
                    className={style.dropdownLink}
                  >
                    {microcopy.text("headers.primary.links.support.text")}
                  </Link>
                  <Link
                    to="https://community.box.com/events?tab=upcoming"
                    microcopy={microcopy}
                    className={style.dropdownLink}
                  >
                    {microcopy.text("headers.primary.links.events.text")}
                  </Link>
                </div>
              </div>
            </div>
            <div className={style.featuredSection}>
              <img alt="" src={connectFeatured} />
              <figcaption>
                <span className={style.tagFeatured}>
                  {microcopy.text("headers.primary.connect_featured.tag.text")}
                </span>
                <span
                  microcopy={microcopy}
                  className={style.featuredTitle}
                >
                  {microcopy.text("headers.primary.connect_featured.title.text")}
                </span>
                {microcopy.text("headers.primary.connect_featured.details.text")}
              </figcaption>
              <Link
                to="https://events.box.com/series/content-ai-box-virtual-summit/landing_page?utm_source=web&utm_medium=gtm&utm_theme=CloudContentManagement&id=701UL00000I3arDYAR&utm_content=dev-site-banner"
                microcopy={microcopy}
                className={style.featuredLink}
              >
                {microcopy.text("headers.primary.connect_featured.cta.text")}
              </Link>
            </div>
          </div>
        </HoverMenu>
        </li>
      )}
      {/* {process.env.GATSBY_FEATURE_OLD_HEADER === "true" && (
        <div>
          {process.env.GATSBY_FEATURE_QUICK_START_GUIDES === "true" && (
            <li>
              <Link
                to="/get-started/"
                microcopy={microcopy}
                className={style.link}
                activeClassName={style.activeLink}
                partiallyActive
              >
                {microcopy.text("guides.titles.quick_start_guides")}
              </Link>
            </li>
          )}
          {process.env.GATSBY_FEATURE_GUIDES === "true" && (
            <li>
              <Link
                to="/guides/"
                microcopy={microcopy}
                className={style.link}
                activeClassName={style.activeLink}
                partiallyActive
              >
                {microcopy.text("headers.primary.links.guides.text")}
              </Link>
            </li>
          )}
          {process.env.GATSBY_FEATURE_REFERENCE === "true" && (
            <li>
              <Link
                to="/reference/"
                microcopy={microcopy}
                className={style.link}
                activeClassName={style.activeLink}
                partiallyActive
              >
                {microcopy.text("headers.primary.links.api_reference.text")}
              </Link>
            </li>
          )}
          {process.env.GATSBY_FEATURE_SAMPLE_CODE_CATALOG === "true" && (
            <li>
              <Link
                to="/sample-code/"
                microcopy={microcopy}
                className={style.link}
                activeClassName={style.activeLink}
                partiallyActive
              >
                {microcopy.text("headers.primary.links.sample_code.text")}
              </Link>
            </li>
          )}
          {process.env.GATSBY_FEATURE_PAGES === "true" && (
            <li>
              <Link
                to="/sdks-and-tools/"
                microcopy={microcopy}
                className={style.link}
                activeClassName={style.activeLink}
                partiallyActive
              >
                {microcopy.text("headers.primary.links.sdks_and_tools.text")}
              </Link>
            </li>
          )}
          {process.env.GATSBY_FEATURE_PAGES === "true" && (
            <li>
              <Link
                to="/support/"
                microcopy={microcopy}
                className={style.link}
                activeClassName={style.activeLink}
                partiallyActive
              >
                {microcopy.text("headers.primary.links.support.text")}
              </Link>
            </li>
          )}
        </div>
      )} */}
    </ul>
  </nav>
)

export default Menu
